export default "/assets/images/badge-02.webp?d301ab7923eebb37e0901fd915205713";